import { createRoot } from 'react-dom/client';
import AppV3 from './AppV3.tsx';
import './index.css';
import { registerServiceWorker } from './lib/offline/registerServiceWorker';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root container not found');
}

createRoot(rootElement).render(<AppV3 />);

registerServiceWorker();


